import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import lightBlue from "@material-ui/core/colors/lightBlue";
import {withStyles} from '@material-ui/core/styles';

const styles = {
	root: {
		backgroundColor: lightBlue[600],
		color: '#FFF',
		margin: '20px auto',
		'&$contained:hover': {
			backgroundColor: lightBlue[800],
		}
	},
	contained: {}
};

class ContactFormSubmitButton extends Component {
	render() {
		const {classes} = this.props;
		return (
			<Button type='submit'
			        disabled={!this.props.isValid}
			        classes={{root: classes.root, contained: classes.contained}}
			        variant='contained'
			        size='large'
			        margin='normal'>go!</Button>
		);
	}
}

export default withStyles(styles)(ContactFormSubmitButton);